import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'FHE__SET_USERS':
            return core.setUsers(state, action.users);
        case 'FHE__UPDATE_HOME_USERS':
            return core.updateHomeUsers(state, action.homeUsers);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Users/reducer.js